import { Button } from '@material-ui/core';
import { rhythm } from 'Themes/typography';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: ${rhythm(2)} 0;
`;

const ButtonContainer = styled.div`
  max-width: 16.458rem;
`;

const CustomButton = styled(Button)`
  &&& {
    font-weight: 600;
  }
`;

const SendSlip = ({ onSubmit }) => (
  <Container>
    <ButtonContainer>
      <CustomButton
        onClick={onSubmit}
        variant="contained"
        color="primary"
        fullWidth
      >
        RESPOND
      </CustomButton>
    </ButtonContainer>
  </Container>
);

export default SendSlip;
